(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const breakpoint = window.matchMedia('(min-width: 750px)');

  const shouldConserveData = () => Boolean(navigator.connection && navigator.connection.saveData);

  const syncPlayback = (video) => {
    const canAutoplay = video.dataset.autoplay === 'true' && !reduceMotion.matches && !shouldConserveData();

    if (!canAutoplay) {
      video.pause();
      video.removeAttribute('autoplay');
      video.preload = 'none';
      video.classList.remove('is-ready');
      return;
    }

    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.preload = 'auto';
    video.play().catch(() => {
      video.pause();
    });
  };

  const initHeroVideo = (video) => {
    if (video.dataset.initialized === 'true') return;

    video.dataset.initialized = 'true';
    const revealVideo = () => video.classList.add('is-ready');

    if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
      revealVideo();
    } else {
      video.addEventListener('loadeddata', revealVideo, { once: true });
    }

    video.addEventListener('error', () => video.classList.remove('is-ready'));
    syncPlayback(video);

    reduceMotion.addEventListener('change', () => {
      syncPlayback(video);
    });
    breakpoint.addEventListener('change', () => {
      video.classList.remove('is-ready');
      video.pause();
      video.load();
      syncPlayback(video);
    });
  };

  const initHeroVideos = (scope = document) => {
    scope.querySelectorAll('[data-seasonal-hero-video]').forEach(initHeroVideo);
  };

  initHeroVideos();

  document.addEventListener('shopify:section:load', (event) => {
    initHeroVideos(event.target);
  });
})();
